import * as React from 'react'
import { Input } from '@/components/ui/input'
import { cn } from '@/lib/utils'

interface InputGroupProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'prefix'> {
  prefix?: React.ReactNode
  suffix?: React.ReactNode
  prefixClassName?: string
  suffixClassName?: string
}

export const InputGroup = React.forwardRef<HTMLInputElement, InputGroupProps>(
  (
    { prefix, suffix, prefixClassName, suffixClassName, className, ...props },
    ref,
  ) => {
    const hasAddon = prefix || suffix

    if (!hasAddon) {
      return <Input ref={ref} className={className} {...props} />
    }

    return (
      <div className="flex w-full items-center">
        {prefix && (
          <div
            className={cn(
              'flex h-10 items-center rounded-l-md border border-r-0 border-input bg-muted px-3 text-sm text-muted-foreground',
              prefixClassName,
            )}
          >
            {prefix}
          </div>
        )}
        <Input
          ref={ref}
          className={cn(
            prefix && 'rounded-l-none',
            suffix && 'rounded-r-none',
            className,
          )}
          {...props}
        />
        {suffix && (
          <div
            className={cn(
              'flex h-10 items-center rounded-r-md border border-l-0 border-input bg-muted px-3 text-sm text-muted-foreground',
              suffixClassName,
            )}
          >
            {suffix}
          </div>
        )}
      </div>
    )
  },
)

InputGroup.displayName = 'InputGroup'
